import BlueprintToolbar from "./components/BlueprintToolbar";
import BlueprintTable from "./components/BlueprintTable";

/**
 * The layout belongs to the route, not the page — see routes/blueprints.tsx.
 * This is the same shape MCPs follows and the one every migrated screen should.
 */
const BlueprintsPage = () => (
  <div className="p-2 sm:p-4">
    <BlueprintToolbar />
    <BlueprintTable />
  </div>
);

export default BlueprintsPage;
